<script>
import router from "../../router/routes";
import NavBar from "@/components/nav-bar";
import SideBar from "@/components/side-bar";
import Footer from "@/components/footer";
import RegionalCpfModal from "@/components/regional-cpf-modal";
import AfiliadosRegulamentoModal from "@/components/afiliados-regulamento-modal";
import OnboardingModal from "@/components/onboarding-modal";
import MetasOnboardingModal from "@/components/metas-onboarding-modal";
import JornadaDiariaModal from "@/components/jornada-diaria-modal";
import RankingFotoModal from "@/components/ranking-foto-modal";
import { preferenciasUi, aplicarMenuRecolhido } from "@/utils/preferencias-ui";

export default {
  components: {
    NavBar,
    SideBar,
    Footer,
    RegionalCpfModal,
    AfiliadosRegulamentoModal,
    OnboardingModal,
    MetasOnboardingModal,
    JornadaDiariaModal,
    RankingFotoModal,
  },
  beforeCreate: function() {
    document.body.className = 'main';
  },
  data() {
    return {
      isMenuCondensed: false,
      preferencias: preferenciasUi,
    };
  },
  created: () => {
    document.body.removeAttribute("data-layout", "horizontal");
    document.body.removeAttribute("data-topbar", "dark");
  },
  // O beforeCreate troca o className inteiro do body; o "menu recolhido"
  // (preferência salva) é reaplicado a cada montagem do layout.
  mounted() {
    aplicarMenuRecolhido();
  },
  methods: {
    toggleMenu() {
      document.body.classList.toggle("sidebar-enable");

      if (window.screen.width >= 992) {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
        });
      } else {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
        });
      }
      this.isMenuCondensed = !this.isMenuCondensed;
    },
    // Fecha a gaveta do menu ao tocar fora dela. Entre 541px e 1024px a
    // sidebar abre como painel de 250px sobre o conteudo e, ate aqui, o unico
    // jeito de fecha-la era achar de novo o botao de hamburguer no topo.
    closeMenu() {
      document.body.classList.remove("sidebar-enable");
      this.isMenuCondensed = false;
    },
    toggleRightSidebar() {
      document.body.classList.toggle("right-bar-enabled");
    },
    hideRightSidebar() {
      document.body.classList.remove("right-bar-enabled");
    }
  }
};
</script>

<template>
  <div id="layout-wrapper">
    <NavBar :isCondensed="isMenuCondensed" />
    <!-- isCondensed recria o simplebar ao recolher: no modo recolhido os
         submenus abrem como painel flutuante e precisam de overflow visível. -->
    <SideBar :isCondensed="preferencias.menuRecolhido" />
    <!--
      Veu que aparece atras da gaveta do menu no mobile/tablet. Fica FORA do
      SideBar de proposito: o side-nav.vue marca o item ativo percorrendo o DOM
      na mao (getElementsByClassName + parentElement), e qualquer no novo
      dentro da arvore <ul>/<li> dele quebraria esse realce.
    -->
    <div class="sidebar-backdrop" @click="closeMenu"></div>
    <div class="main-content">
      <div class="page-content">
        <div class="container-fluid">
          <slot />
        </div>
      </div>
      <Footer />
    </div>
    <!--
      Ordem de precedência dos modais globais (ver onboarding-modal.vue):
      RegionalCpfModal e AfiliadosRegulamentoModal são bloqueantes; o
      OnboardingModal só abre quando nenhum dos dois está em cena.
      MetasOnboardingModal (planejamento de metas) é o ÚLTIMO: só abre depois
      do tour concluído e com nenhum dos anteriores em cena (ver o componente).
      JornadaDiariaModal (Minhas Metas em fases, 1ª abertura do dia) vem DEPOIS de
      todos: exige planejamento concluído e nenhum fluxo acima em cena
      (utils/jornada.js::fluxoGlobalBloqueado).
      RankingFotoModal só abre ao entrar numa tela /biteams/rk-* sem a Foto para
      o Ranking enviada, 1x por login (ver o componente).
    -->
    <RegionalCpfModal />
    <AfiliadosRegulamentoModal />
    <OnboardingModal />
    <MetasOnboardingModal />
    <!-- Minha Jornada oculta temporariamente a pedido do usuário — remover o v-if para reativar -->
    <JornadaDiariaModal v-if="false" />
    <RankingFotoModal />
  </div>
</template>
